"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../util");
var app_1 = require("./app");
var identRE = /^\w+(\.\w+)?/;
var versionRE = /^[\d._]+/;
var opRE = /^\s*[>=<]+\s*/;
var commaRE = /^\s*,\s*/;
var andRE = /^\s*and\s*/;
var ERR_IDENTITY = 0;
var ERR_VERSION = 1;
var errMsg = ['identity is not valid', 'version is not valid'];
var SYSTEM = 0;
var APP = 1;
var identityList = {
    passenger: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    driver: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    finance: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    daijia: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    didies: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    kflowerPassenger: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    kflowerDriver: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    globalPassenger: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    globalDriver: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    lite: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    mini: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    xiaojuchefu: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    qingjuchelian: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    driverFreight: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    shunfengche: {
        type: APP,
        compare: app_1.compareAppVersion
    },
    weixin: {
        type: APP
    },
    alipay: {
        type: APP
    },
    ios: {
        type: SYSTEM,
        compare: app_1.compareSysVersion
    },
    android: {
        type: SYSTEM,
        compare: app_1.compareSysVersion
    }
};
function initIS(bridge) {
    bridge.is = is;
}
exports.initIS = initIS;
function is(rule) {
    try {
        return parse(tokenize(rule));
    }
    catch (e) {
        util_1.globalHandleError(e.message, app_1.app);
        return false;
    }
}
exports.is = is;
function tokenize(rule) {
    var soFar = rule;
    var groups = [];
    var matched;
    while (soFar) {
        var tokens = void 0;
        var match = commaRE.exec(soFar);
        if (!matched || match) {
            if (match) {
                soFar = soFar.slice(match[0].length) || soFar;
            }
            tokens = [];
            groups.push(tokens);
        }
        matched = false;
        var more = true;
        var error = -1;
        do {
            var expression = {};
            match = identRE.exec(soFar);
            if (match) {
                matched = match.shift();
                expression.identity = matched;
                soFar = soFar.slice(matched.length);
            }
            else {
                error = ERR_IDENTITY;
                break;
            }
            match = opRE.exec(soFar);
            if (match) {
                matched = match.shift();
                expression.operator = matched.trim();
                soFar = soFar.slice(matched.length);
                match = versionRE.exec(soFar);
                if (match) {
                    matched = match.shift();
                    expression.version = matched;
                    soFar = soFar.slice(matched.length);
                }
                else {
                    error = ERR_VERSION;
                    break;
                }
            }
            tokens.push(expression);
            match = andRE.exec(soFar);
            if (match) {
                matched = match.shift();
                soFar = soFar.slice(matched.length);
                more = true;
            }
            else {
                more = false;
            }
        } while (more);
        if (error !== -1) {
            util_1.globalHandleError("The tokenize rule is error, " + errMsg[error], app_1.app);
        }
    }
    return groups;
}
function parse(groups) {
    var ret = false;
    util_1.each(groups, function (tokens) {
        var result = true;
        util_1.each(tokens, function (expression) {
            var identity = expression.identity, operator = expression.operator, version = expression.version;
            var ident = identityList[identity];
            if (!ident) {
                util_1.globalHandleError("unknown identity: " + identity, app_1.app);
                result = false;
                return result;
            }
            var equal = false;
            var type = ident.type;
            if (type === SYSTEM) {
                equal = app_1.app.system === identity;
            }
            else if (type === APP) {
                if (identity === 'driver') {
                    equal = !!((app_1.app.env === identity) || app_1.app.driver);
                }
                else {
                    equal = app_1.app.env === identity;
                }
            }
            if (!operator || !equal) {
                result = result && equal;
            }
            else {
                var compareFn = ident.compare;
                result = result && compareFn(operator, version);
            }
        });
        ret = ret || result;
    });
    return ret;
}
